import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { registerUser } from '../api/usersApi';
import { getProfesionValue } from '../model/userConstants';

export const useCreateUserForm = () => {
  const navigate = useNavigate();
  const [nombre, setNombre] = useState('');
  const [apellidos, setApellidos] = useState('');
  const [usuario, setUsuario] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [profesional, setProfesional] = useState('');
  const [role, setRole] = useState('SANITARIO');
  const [openGood, setOpenGood] = useState(false);
  const [openBad, setOpenBad] = useState(false);
  const [errors, setErrors] = useState({
    nombre: '',
    apellidos: '',
    usuario: '',
    password: '',
    email: '',
  });

  const validate = () => {
    const nextErrors = {
      nombre: /\d/.test(nombre) || nombre.trim() === '' ? 'El nombre no puede tener numeros' : '',
      apellidos: /\d/.test(apellidos) || apellidos.trim() === '' ? 'Los apellidos no pueden tener numeros' : '',
      usuario: /\s/.test(usuario) || usuario.trim() === '' ? 'El usuario no puede tener espacios en blanco' : '',
      password: /\s/.test(password) || password.trim().length < 8 || password.trim().length > 16 ? 'La contraseña debe tener entre 8 y 16 caracteres' : '',
      email: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(email) ? '' : 'Introduce un email valido',
    };
    setErrors(nextErrors);
    return !Object.values(nextErrors).some(Boolean);
  };

  const handleSave = async () => {
    if (!validate()) {
      setOpenBad(true);
      return;
    }

    try {
      await registerUser({
        username: usuario,
        firstname: nombre,
        lastname: apellidos,
        email,
        password,
        profesional: getProfesionValue(profesional),
        role,
      });
      setOpenGood(true);
      setTimeout(() => { navigate('/homeAdmin'); }, 1500);
    } catch (error) {
      console.error('Error al crear usuario:', error);
      setOpenBad(true);
    }
  };

  return {
    nombre, setNombre,
    apellidos, setApellidos,
    usuario, setUsuario,
    email, setEmail,
    password, setPassword,
    profesional, setProfesional,
    role, setRole,
    openGood, setOpenGood,
    openBad, setOpenBad,
    errors,
    handleSave,
  };
};
